export const EngagementLetterGetters = {
  engagementLetters: state => state.engagementLetters,
}
